import { ButtonProps } from "@/components/common/button-with-icon";
import styles from "@/components/common/styles/text-button.module.scss";
import useHover from "@/hooks/use-hover";

interface TextButtonProps extends ButtonProps {
  text: string;
  textColor?: string;
  textPointeroverColor?: string;
}

const TextButton = ({
  isEnabled,
  handleClick,
  text,
  textColor,
  textPointeroverColor,
}: TextButtonProps) => {
  const { isHovering } = useHover();
  return (
    <button
      className={styles.text_button}
      disabled={!isEnabled}
      onClick={handleClick}
      style={{
        color: (isHovering ? textPointeroverColor : textColor) ?? "white",
      }}
    >
      {text}
    </button>
  );
};
export default TextButton;
